import { ChangeDetectionStrategy, Component, ElementRef, OnInit, ViewEncapsulation } from '@angular/core';
import { AuthService } from 'src/app/api/core/auth/auth.service';
import { BaseWalkthroughStepComponent } from '../base-walkthrough-step/base-walkthrough-step.component';

@Component({
  selector: 'hub-item-summary-walkthrough',
  templateUrl: './item-summary-walkthrough.component.html',
  styleUrls: ['./item-summary-walkthrough.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ItemSummaryWalkthroughComponent extends BaseWalkthroughStepComponent {
  constructor(public el: ElementRef, public auth: AuthService) {
    super(el);
  }
}
